import { createFileRoute } from "@tanstack/react-router";
import { RuleSetDetail } from "@/components/data-quality/rule-set-screens";
import { dqRuleSets } from "@/api/data-quality";

export const Route = createFileRoute("/_app/data-quality/rules/$id")({
  component: RuleDetail,
});

function RuleDetail() {
  const { id } = Route.useParams();
  return (
    <RuleSetDetail
      kind="dq"
      query={dqRuleSets.useOne(id)}
      save={dqRuleSets.useSave()}
      remove={dqRuleSets.useRemove().mutateAsync}
      crumbs={[
        { label: "Data Quality", to: "/data-quality" },
        { label: "Rule Sets", to: "/data-quality/rules" },
      ]}
      backTo="/data-quality/rules"
    />
  );
}
